import { render, staticRenderFns } from "./ColorModePicker.vue?vue&type=template&id=7ec55cd8&scoped=true"
import script from "./ColorModePicker.vue?vue&type=script&lang=js"
export * from "./ColorModePicker.vue?vue&type=script&lang=js"
import style0 from "./ColorModePicker.vue?vue&type=style&index=0&id=7ec55cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec55cd8",
  null
  
)

export default component.exports